import React, { useEffect, useState } from 'react';
import { Box, Grid,InputLabel, ListItem, Select, MenuItem } from '@mui/material';
import { connect } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import ProgressFlowChart from './ProgressFlowChart';
import CustomMarker from './CustomMarker';
import JobService from "../../services/console_services/Jobs";
import { useMsal } from '@azure/msal-react';


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5, 2.5, 1.25, 10),
    fontFamily: theme.fontFamily,
  },
  gridItem: {
    paddingTop: theme.spacing(2),
  },
  select: {
    borderColor: 'transparent',
    borderStyle: 'none',
    height: '30px',
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    '&.MuiOutlinedInput-root': {
    margin: "0px 5px",
    },
  },
   selectList : {
        borderColor: 'transparent',
        borderStyle: 'none',
        height: '30px',
        width: "110px",
        borderRadius: "4px !important",
        background: "var(--Neutral-Colors-White, #FFF)",
        fontSize: "14px !important",
        color: "#404041 !important",
        '&.MuiOutlinedInput-root': {
            margin: "0px 5px",
        },
    },
}));

const ModuleRunStatusByNetwork = () => {

  const classes = useStyles(); 
  // const dispatch = useDispatch();
  const { instance } = useMsal();
 
 const [jobDataByNetwork, setJobsDataByNetwork] = useState([]);
 const [env, setEnv] = useState ("dev");
 const [network, setNetwork] = useState ("ambient");

  // Use the custom hook to fetch data
  
  const fetchJobRunsByNetwork = async () => {
    const params = {
      network: network,
      env: env
    };
    try {
      const response = await JobService.getJobBtNetwork(params, instance);
      if (response?.data) {
        setJobsDataByNetwork(response?.data || []);
      }
    } catch (error) {
      console.error('fetchJobRuns', error);
    } 
  };

  useEffect(() => {
    fetchJobRunsByNetwork();
  }, [network, env]);



  const handleEnvChange = (event) => {
    setEnv(event?.target?.value);
  };

  const handleNetworkChange = (event) => {
    setNetwork(event?.target?.value);
  };

  return (
    <Box className={classes.root}>
      <div style={{display: "flex",  alignItems: "center"}}>
      <div style={{display: "flex", alignItems: "center"}}>
        <div>
          <InputLabel  
            id="date-label"
          >
            Environment
          </InputLabel>
        </div>
        <ListItem>
          <Select
            value={env}
            onChange={handleEnvChange}
            className={classes.selectList}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            sx={classes.select}
          >
            <MenuItem value={"dev"}>
              Dev
            </MenuItem>
            <MenuItem value={"pp"}>
              PreProd
            </MenuItem>
            <MenuItem value={"prod"}>
              Prod
            </MenuItem>
          </Select>
        </ListItem>
      </div>
      <div style={{display: "flex", alignItems: "center"}}>
        <div>
          <InputLabel  
            id="date-label"
          >
            Network
          </InputLabel>
        </div>
        <ListItem>
          <Select
            value={network}
            onChange={handleNetworkChange}
            className={classes.selectList}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            sx={classes.select}
          >
            <MenuItem value={"ambient"}>
              Ambient
            </MenuItem>
            <MenuItem value={"Chilled"}>
              Chilled
            </MenuItem>
            <MenuItem value={"frozen"}>
              Forzen
            </MenuItem>
             <MenuItem value={"npw"}>
              NPW
            </MenuItem>
          </Select>
        </ListItem>
      </div>
      </div>
      <ProgressFlowChart data={jobDataByNetwork} />
    </Box>
  );
};


export default ModuleRunStatusByNetwork;
